import { TestAutomationTools } from './test-automation';

/**
 * Amplitude instrumentation metadata for LevelDocs plugin downloads (EAP-43944).
 *
 * The event itself (`Plugin Downloaded`) and its `event_properties` are emitted from the client;
 * user properties and tenant/workspace/digital property group properties are attached server-side
 * by the client instrumentation event handler.
 */
export namespace LevelDocsAmplitude {
  export const INSTRUMENTATION_EVENTS = {
    PLUGIN_DOWNLOADED: 'Plugin Downloaded',
  } as const;

  export namespace PluginName {
    export const WORD = 'Word';
    export const POWERPOINT = 'PowerPoint';
    export const EXCEL = 'Excel';
  }

  export namespace EventPagePath {
    export const TOOLS_AND_EXTENSIONS = 'Tools & extensions';
  }

  /**
   * LevelDocs tool ids follow the pattern `leveldocs_<plugin>_win_<arch>_<scope>`
   * (e.g. `leveldocs_word_win_64_user`). This maps the `<plugin>` segment to the
   * human readable plugin name so downloads can be compared per plugin in Amplitude.
   */
  const PLUGIN_NAME_BY_SEGMENT: Readonly<Record<string, string>> = {
    word: PluginName.WORD,
    ppt: PluginName.POWERPOINT,
    excel: PluginName.EXCEL,
  };

  export function getPluginName(toolId: TestAutomationTools): string | undefined {
    const [prefix, plugin]: string[] = toolId.split('_');
    if (prefix !== 'leveldocs') {
      return undefined;
    }
    return PLUGIN_NAME_BY_SEGMENT[plugin];
  }
}
